import { createApp } from 'vue'
import router from 'router'
import store from 'store'
import 'assets/styles/styles.css'
import App from './App.vue'
import axios from 'axios'
import ElementPlus from 'element-plus'
import "element-plus/dist/index.css"
import 'element-plus/theme-chalk/display.css'

var cApp = createApp(App)
cApp.config.globalProperties.$axios = axios
cApp.use(store).use(router).use(ElementPlus).mount('#app')
